import TenantStore from "@tenant_admin/stores/TenantStore";
import PaymentMethodStore from "@tenant_admin/stores/PaymentMethodStore";
import CompanyStore from "@shared/components/Company/CompanyStore";

import _ from "lodash";

class InvoiceReportFormStore {
  constructor (reportName, reportUrl = "/api/v4") {
    this.reportName = reportName;
    this.reportUrl = reportUrl;
    this.reportStatus = "";

    this.data = {
      paymentMethodId: "",
      currencyId: "",
      customerName: "",
      invoiceMerchantNumber: "",
      fromDate: "",
      toDate: "",
      paymentFrom: "",
      paymentTo: "",
      paymentMethods: [],
      currencies: [],
      invoice_voucher_type: ""
    };
  }

  async loadPaymentMethodsAndCurrencies () {
    const currencyTenants = await TenantStore.methods.fetchCurrencyTenants(
      Dashboard.currentTenant.id,
      CompanyStore.currentCompany.country.id
    );

    this.data.currencies = _.map(currencyTenants, c => c.currency);
    this.data.paymentMethods = await PaymentMethodStore.methods.fetchPaymentMethods(
      Dashboard.currentTenant.id
    );
  }

  async loadReports (companyId) {
    const response = await fetch(
      `${this.reportUrl}/${this.reportName}?` +
        `invoice_company_id=${companyId}&` +
        `invoice_status=${this.reportStatus}&` +
        `invoice_payment_method_id=${this.data.paymentMethodId}&` +
        `invoice_currency_id=${this.data.currencyId}&` +
        `invoice_customer_name=${this.data.customerName}&` +
        `invoice_merchant_number=${this.data.invoiceMerchantNumber}&` +
        `from_invoice_date=${this.formatDate(this.data.fromDate)}&` +
        `to_invoice_date=${this.formatDate(this.data.toDate)}&` +
        `from_invoice_payment_date=${this.formatDate(this.data.paymentFrom)}&` +
        `to_invoice_payment_date=${this.formatDate(this.data.paymentTo)}&` +
        `invoice_voucher_type=${this.data.invoice_voucher_type}`

    );

    const responseJSON = await response.json();

    return responseJSON.invoice_reports;
  }

  formatDate (dateString) {
    return dateString || "";
  }

  changeReportStatus (status) {
    this.reportStatus = status;
  }
};

export default InvoiceReportFormStore;
